import { getCountries } from "@/api/countries";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { countryKeys } from "./keys";
import { CountryList } from "./schema";

export function getCountriesQueryOptions(
	options?: QueryOptionsWithoutKeyAndFn<CountryList>,
) {
	return queryOptions({
		queryKey: countryKeys.countries(),
		queryFn: getCountries,
		...options,
	});
}

export default function useGetCountries(
	options?: QueryOptionsWithoutKeyAndFn<CountryList>,
) {
	return useQuery(getCountriesQueryOptions(options));
}
